<template>
  <div style="heigit:100%;display:flex;margin-left:15px">
    <div v-for="(item,index) in config" :key="index" style="" class="wrapper">
      <!-- <img :class="['img']" :style="item.icon.style" v-if="item.icon.path" :src="item.icon.path"> -->
      <span :class="['img','left']" :style="{backgroundImage:`url(${item.icon.path})`}" v-if="item.icon.path"></span>
      <i :class="['icon','left',item.icon.name]" :style="item.icon.style" v-else></i>
      <div style="flex:1" class="right">
        <fx-digital-flop :config="item.digit" class="item"></fx-digital-flop>

        <div v-if="item.descrition&&item.descrition.text" :style="item.descrition.style" class="descrition">
          {{item.descrition.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import fxDigitalFlop from '../../fxDigitalFlop/src/main'
//驼峰转连字符
function toHyphen(params) {
  return params.replace(/([A-Z])/g, '-$1').toLowerCase()
}
export default {
  name: 'fxDigitalList',
  components: { fxDigitalFlop },
  data() {
    return {
      config: []
    }
  },
  watch: {
    config: {
      handler(newVal, oldVal) {
        const { option, title } = newVal || this.config

      },
      // deep: true
      // immediate:true
    }
  },
  methods: {
    setConfig(val) {
      // this.config = Object.assign({}, this.config, val)
      this.config = val
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  flex: 1;
  display: flex;
  padding-right: 30px;
  box-sizing: border-box;
  .left{
    width: 40px;
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .item {
    // width: 120px;
    width:100%;
    height: 30px;
  }
}
.img {
  display: flex;
  width: 40px;
  background-repeat: no-repeat;
  background-position: center;
}
.icon {
  font-size: 40px;
  display: flex;
  align-items: center;
}
.descrition {
  font-size: 20px;
}
</style>